import React, { useState, useEffect } from 'react'
import { styled } from 'styled-components'
import { motion } from 'framer-motion'
import { Link, useParams } from 'react-router-dom'


function Cuisine() {
    let params = useParams();
    const [cuisine, setCuisine] = useState([])

    useEffect(()=>{
        getCuisine(params.type);
        console.log(`gettin the cuisine....${params.type}`)
      }, [params.type])


    const getCuisine = async (name) =>{
        const data = await fetch(`https://api.spoonacular.com/recipes/complexSearch?apiKey=${process.env.REACT_APP_API_KEY}&number=9&cuisine=${name}`);
        const recipes = await data.json();
        setCuisine(recipes.results)
    }

  return (
    <Grid>
        {cuisine.map((item)=>{
            return (
                <Card key={item.id}>
                  <Link to={'/recipe/'+ item.id}>
                    <img src={item.image} alt={item.title} />
                    <h4>{item.title}</h4>
                  </Link>
                </Card>
            )
        })}
    </Grid>
  )
}


export const Grid = styled.div`
display: grid;
grid-template-columns: repeat(auto-fit, minmax(20rem, 1fr));
grid-gap: 3rem;
`

export const Card = styled.div`
  img {
    width: 100%;
    border-radius: 2rem;
  }

  a {
    text-decoration: none;
  }

  h4 {
    text-align: center;
    padding: 1rem;
  }`


export default Cuisine